<script setup lang="ts">
import { DtRootLayout } from '@dialpad/dialtone/vue3/lib/root-layout';
import ModalWrapper from '@/app/components/modal/ModalWrapper.vue';
import NavigationSideBar from '@/app/components/NavigationSideBar/NavigationSideBar.vue';
import ToastNotoConsumer from '@/app/components/ToastNotoConsumer/ToastNotoConsumer.vue';
import { useAccessGuard } from '@/access-guard';
import SidebarWrapper from '@/app/components/sidebar/SidebarWrapper.vue';

useAccessGuard();
</script>
<template>
  <ToastNotoConsumer />
  <DtRootLayout
    class="d-w100p d-h332 d-bgc-primary"
    header-class="d-ol-none"
    content-class="d-ol-none"
    footer-class="d-ol-none"
    sidebar-class="d-bgc-secondary d-br d-br1 d-bc-subtle d-w216 lg:d-w164 d-ol-none"
  >
    <template #sidebar>
      <NavigationSideBar />
    </template>
    <div class="d-h100p">
      <ModalWrapper />
      <div class="d-d-flex d-h100p d-w100p d-of-hidden">
        <div class="d-fl-shrink1 d-of-auto d-w100p">
          <RouterView class="d-wmn828" />
        </div>
        <SidebarWrapper class="d-fl-shrink0" />
      </div>
    </div>
  </DtRootLayout>
</template>
